import { Pane } from 'tweakpane';

// Garde une seule instance du panneau
let pane: Pane | null = null;

/**
 * Un composable pour obtenir une instance unique (singleton) de Tweakpane.
 * @returns L'instance du panneau Tweakpane.
 */
export function useTweakpane() {
  if (!pane) {
    // Crée le panneau s'il n'existe pas encore
    pane = new Pane();
  }
  return pane;
}
